module.exports = __webpack_public_path__ + "141d4a85/img/link-icon.fa09ed66.svg";